import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import TaxAccountAtom from '../../../recoil/cashout/TaxAccountAtom';

import CashoutTaxForm from './forms/CashoutTaxForm';
import { resolveTaxStatus } from './TaxStatusResolver';

export default function CashoutTaxStatus() {
  const { t } = useTranslation(null, { useSuspense: false });
  const taxAccount = useRecoilValue(TaxAccountAtom);
  const resolvedStatus = resolveTaxStatus(taxAccount);

  const [showForm, setShowForm] = useState(false);

  if (!resolvedStatus) {
    return null;
  }

  const {
    tone,
    iconClass,
    titleKey,
    textKey,
    formButton,
  } = resolvedStatus;

  const handleClose = async () => {
    setShowForm(false);
  };

  return (
    <>
      {showForm && (
        <CashoutTaxForm
          form={{
            formUrl: formButton?.formUrl || null,
            requestForce: false,
          }}
          onContinue={handleClose}
          onClose={handleClose}
        />
      )}

      <div className={`cashout-status-banner cashout-status-banner--${tone}`} role="alert">
        <span
          className={`cashout-status-banner__icon phoenix-icon ${iconClass}`}
          aria-hidden="true"
        />
        <div className="cashout-status-banner__body">
          <p className="cashout-status-banner__title">{t(titleKey)}</p>
          <p className="cashout-status-banner__text">
            {t(textKey)}
          </p>
          {formButton && (
            <button
              type="button"
              className="cashout-status-banner__action"
              onClick={() => setShowForm(true)}
            >
              {t(formButton.labelKey)}
            </button>
          )}
        </div>
      </div>
    </>
  );
}
